<template>
  <div class="wraper" id="PlatForm" v-loading="loading">
    <!-- 头部 -->
    <div class="heads">
      <div class="header_box">
        <h1>大数据积分排行榜</h1>
        <span class="el-dropdown-link tohome" @click="RouteGo('Works')" style="color: #fff;cursor: pointer;">
          <i class="el-icon-switch-button el-icon--right"></i>
          退出
        </span>
      </div>
    </div>
    <!-- 排名 -->
    <div class="rankings_box">
      <div>
        <!-- 综合积分排名 与 支部任务积分排行 -->
        <div class="points_ranking">
          <div class="points_left">
            <ul>
              <li>党组织量化考核积分排行</li>
              <li>
                <div class="tow_box">
                  <p class="tow_text">2</p>
                  <div class="img_box" v-if="allData[1]">
                    <!-- <img v-if="allData[1].real_avatar" :src="allData[1].real_avatar" alt="头像" /> -->
                    <p class="img_text_box">
                      <span class="fenshu_Combox">
                        {{ allData[1].integral }} 分
                      </span>
                      <span class="name_Combox">
                        {{ allData[1].organization_name }}
                      </span>
                    </p>
                  </div>
                  <img src="../../../../assets/images/dj_h.png" alt="图片" class="huangguang" />
                </div>
                <div class="one_box">
                  <span class="tow_text">1</span>
                  <div class="img_box" v-if="allData[0]">
                    <!-- <div>
                      <img v-if="allData[0].real_avatar" :src="allData[0].real_avatar" alt="头像" />
                    </div> -->
                    <p class="img_text_box">
                      <span class="fenshu_Combox">
                        {{ allData[0].integral }} 分
                      </span>
                      <span class="name_Combox">
                        {{ allData[0].organization_name }}
                      </span>
                    </p>
                  </div>
                  <img src="../../../../assets/images/j_h.png" alt="图片" class="huangguang" />
                </div>
                <div class="three_box">
                  <span class="tow_text">3</span>
                  <div class="img_box" v-if="allData[2]">
                    <!-- <img v-if="allData[2].real_avatar" :src="allData[2].real_avatar" alt="头像" /> -->
                    <p class="img_text_box">
                      <span class="fenshu_Combox">
                        {{ allData[2].integral }} 分
                      </span>
                      <span class="name_Combox">
                        {{ allData[2].organization_name }}
                      </span>
                    </p>
                  </div>
                  <img src="../../../../assets/images/hui_h.png" alt="图片" class="huangguang" />
                </div>
              </li>
              <!-- 其他排名 -->
              <li>
                <div class="auto_boxs" style="padding-top:10px;">
                  <!-- allData -->
                  <div class="v_for_box" style="justify-content:space-around;align-items:center;"
                    v-for="(item,index) in otherallData" :key="index">
                    <div>
                      {{index+1}}
                    </div>
                    <div style="width:47px;height:100%;">
                      <img style="height:100%;" :src="item.real_avatar" alt="" />
                    </div>
                    <div style="width:300px;">
                      {{ item.organization_name }}
                    </div>
                    <div class="fenshu_boxs" style="width:150px;">{{item.integral}}分</div>
                    <!-- <div class="" style="display:flex;width:200px;align-items:center;justify-content: space-around;">
                      <span class="points_wenzi">{{index+1}}</span>
                      <img style="height:100%;"
                        src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2F5b0988e595225.cdn.sohucs.com%2Fimages%2F20180520%2F0473e00bdfd2476fbe0c228a45a1652c.jpeg&refer=http%3A%2F%2F5b0988e595225.cdn.sohucs.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1636250208&t=0e48cf8dc9603a6755e147d704fd67d2"
                        alt="" />
                      <p>{{ item.real_name }}</p>
                    </div>
                    <div class="fenshu_boxs">{{item.integral}}分</div> -->
                  </div>
                  <!-- 循环 -->
                </div>
              </li>
            </ul>
          </div>
          <!-- 支部任务积分排名 -->
          <div class="points_right">
            <ul style="display:flex;flex-direction:column;">
              <li>督查督办任务积分排行</li>
              <li>
                <div class="points_img2 top_10">
                  <p class="noNumber">NO.2</p>
                  <p class="points_consboc" v-if="BranchTask[1]">
                    {{BranchTask[1].organization_name}}
                  </p>
                  <p class="points_consbocs" v-if="BranchTask[1]">
                    {{BranchTask[1].integral}} 分
                  </p>
                </div>
                <div class="points_img">
                  <p class="noNumber">NO.1</p>
                  <p class="points_consboc" v-if="BranchTask[0]">
                    {{BranchTask[0].organization_name}}
                  </p>
                  <p class="points_consbocs" v-if="BranchTask[0]">
                    {{BranchTask[0].integral}} 分
                  </p>
                </div>
                <div class="points_img1 top_10">
                  <p class="noNumber">NO.3</p>
                  <p class="points_consboc" v-if="BranchTask[2]">
                    {{BranchTask[2].organization_name}}
                  </p>
                  <p class="points_consbocs" v-if="BranchTask[2]">
                    {{BranchTask[2].integral}} 分
                  </p>
                </div>
              </li>
              <!-- 其他排名 -->
              <!-- <li>
                <div class="auto_boxs" style="padding-top:10px;">
                  <div class="v_for_box" v-for="(item,index) in otherBranchTask" :key="index">
                    <div class="" style="display:flex;width:200px;align-items:center;justify-content: space-around;">
                      <span class="points_wenzi">{{index+1}}</span>
                      <img :src="item.real_avatar" alt="" />
                      <p>{{item.organization_name}}</p>
                    </div>
                    <div class="fenshu_boxs">{{item.integral}}分</div>
                  </div>
                </div>
              </li> -->
              <li>
                <div class="auto_boxs" style="padding-top:10px;">
                  <!-- allData -->
                  <div class="v_for_box" style="justify-content:space-around;align-items:center;"
                    v-for="(item,index) in otherBranchTask" :key="index">
                    <div>
                      {{index+4}}
                    </div>
                    <div style="width:47px;height:100%;">
                      <img style="height:100%;" :src="item.real_avatar" alt="" />
                    </div>
                    <div style="width:300px;">
                      {{ item.organization_name }}
                    </div>
                    <div class="fenshu_boxs" style="width:150px;">{{item.integral}}分</div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 学习/登录/组织生活 -->
        <div class="bottom_ranking">
          <!-- 学习 -->
          <div class="learning">
            <ul>
              <li>
                学习积分排行榜
              </li>
              <li class="ranking_li2">
                <div class="v_for_box" v-for="(item,index) in learning" :key="index">
                  <div class="rangin_conbox">
                    <div class="rangin_img1">
                      <img v-if="index==0" src="../../../../assets/images/p1.png" alt="" />
                      <img v-if="index==1" src="../../../../assets/images/p2.png" alt="" />
                      <img v-if="index==2" src="../../../../assets/images/p3.png" alt="" />
                    </div>
                    <!-- <img
                      src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2F5b0988e595225.cdn.sohucs.com%2Fimages%2F20180520%2F0473e00bdfd2476fbe0c228a45a1652c.jpeg&refer=http%3A%2F%2F5b0988e595225.cdn.sohucs.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1636250208&t=0e48cf8dc9603a6755e147d704fd67d2"
                      alt="" /> -->
                    <span class="points_name">
                      {{item.organization_name}}</span>
                  </div>
                  <div class="fenshu_boxs">{{item.integral}}分</div>
                </div>
              </li>
            </ul>
          </div>
          <!-- 登录积分 -->
          <div class="learning">
            <ul>
              <li>
                登录积分排行榜
              </li>
              <li class="ranking_li2">
                <div class="v_for_box" v-for="(item,index) in loginData" :key="index">
                  <div class="rangin_conbox">
                    <div class="rangin_img1">
                      <img v-if="index==0" src="../../../../assets/images/p1.png" alt="" />
                      <img v-if="index==1" src="../../../../assets/images/p2.png" alt="" />
                      <img v-if="index==2" src="../../../../assets/images/p3.png" alt="" />
                    </div>
                    <!-- <img
                      :src="item.real_avatar"
                      alt="" /> -->
                    <span class="points_name">
                      {{item.organization_name}}</span>
                  </div>
                  <div class="fenshu_boxs">{{item.integral}}分</div>
                </div>
              </li>
            </ul>
          </div>
          <!-- 组织生活积分排行榜 -->
          <div class="learning">
            <ul>
              <li>
                组织生活积分排行榜
              </li>
              <li class="ranking_li2">
                <div class="v_for_box" v-for="(item,index) in OrganizationalLift" :key="index">
                  <div class="rangin_conbox">
                    <div class="rangin_img1">
                      <img v-if="index==0" src="../../../../assets/images/p1.png" alt="" />
                      <img v-if="index==1" src="../../../../assets/images/p2.png" alt="" />
                      <img v-if="index==2" src="../../../../assets/images/p3.png" alt="" />
                    </div>
                    <!-- <img
                      src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2F5b0988e595225.cdn.sohucs.com%2Fimages%2F20180520%2F0473e00bdfd2476fbe0c228a45a1652c.jpeg&refer=http%3A%2F%2F5b0988e595225.cdn.sohucs.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1636250208&t=0e48cf8dc9603a6755e147d704fd67d2"
                      alt="" /> -->
                    <span class="points_name">
                      {{item.organization_name}}</span>
                  </div>
                  <div class="fenshu_boxs">{{item.integral}}分</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loadingnum: 0,
        loading: false,
        // 积分数据
        all: 0, // 全部
        allData: [], // 综合排名数组
        otherallData: [],// 排除前三的综合排名数组
        login: 1, // 登录
        loginData: [], // 登录积分排行
        loginDatas: [], // 登录积分排行遍历数据
        life: 2, // 生活
        OrganizationalLift: [], // 组织生活积分排行
        OrganizationalLifts: [], // 组织生活积分排行
        learningType: 7, // 学习
        learning: [], // 学习积分排行
        learnings: [], // 遍历数据
        member: 12, //
        BranchTask: [], // 支部任务积分榜
        otherBranchTask: [], // 遍历数据
      };
    },
    created() {
      this.getDataLeader1();
      this.getDataLeader2();
      this.getDataLeader3();
      this.getDataLeader4();
      this.getDataLeader5();
    },
    methods: {
      // 传入一个数组判断数组的长度
      getDataLengthis(data) {
        if (data.length == 0) {
          data.push(
            {
              integral: 0,
              real_name: "无",
              real_avatar:
                "https://info.chinahc.wang/1615781095056_default_photo.jpg",
            },
            {
              integral: 0,
              real_name: "无",
              real_avatar:
                "https://info.chinahc.wang/1615781095056_default_photo.jpg",
            },
            {
              integral: 0,
              real_name: "无",
              real_avatar:
                "https://info.chinahc.wang/1615781095056_default_photo.jpg",
            }
          );
        }
        if (data.length == 1) {
          data.push(
            {
              integral: 0,
              real_name: "无",
              real_avatar:
                "https://info.chinahc.wang/1615781095056_default_photo.jpg",
            },
            {
              integral: 0,
              real_name: "无",
              real_avatar:
                "https://info.chinahc.wang/1615781095056_default_photo.jpg",
            }
          );
        }
        if (data.length == 2) {
          data.push({
            integral: 0,
            real_name: "无",
            real_avatar:
              "https://info.chinahc.wang/1615781095056_default_photo.jpg",
          });
        }
      },
      // 党委查看支部统计数据 0全部 1登录 2生活 5学习 7党员任务排行
      // 获取全部数据
      async getDataLeader1() {
        const data1 = await this.PublicApi(
          "admin/organization/getsIntegralRankByParty",
          { type: 0 }
        );
        this.allData = data1.data;
        console.log(789,this.allData)
        this.otherallData = data1.data.slice(3)
      },
      async getDataLeader2() {
        // 获取登录数据
        const data2 = await this.PublicApi(
          "admin/organization/getsIntegralRankByParty",
          { type: this.login }
        );
        this.loginData = data2.data;
      },
      async getDataLeader3() {
        // 获取组织生活数据
        const data3 = await this.PublicApi(
          "admin/organization/getsIntegralRankByParty",
          { type: this.life }
        );
        this.OrganizationalLift = data3.data;
      },
      async getDataLeader4() {
        // 获取学习数据
        const data4 = await this.PublicApi(
          "admin/organization/getsIntegralRankByParty",
          { type: this.learningType }
        );
        this.learning = data4.data;
      },
      async getDataLeader5() {
        // 获取任务数据
        const data5 = await this.PublicApi(
          "admin/organization/getsIntegralRankByParty",
          { type: this.member }
        );
        this.BranchTask = data5.data;
        this.otherBranchTask = data5.data.slice(3)
      },
    },
  };
</script>

<style scoped lang="less">
  body,
  html {
    height: 100%;
    width: 100%;
    overflow: auto;
  }

  * {
    margin: 0;
    padding: 0;
  }

  .wraper {
    height: 100%;
    background: url("../../../../assets/images/jifen_bg.png") no-repeat top;
    background-size: 100% 100%;
    z-index: 5;
  }

  #PlatForm {
    position: relative;

    // 顶部
    .heads {
      height: 19%;
      background: url("../../../../assets/images/jifen_head1.png") no-repeat top;
      background-size: 105% 140%;
      background-position-y: calc(-1 / 10.8 * 50vh);
      width: 100%;
      position: absolute;
      z-index: 3;

      .el-dropdown-link {
        font-size: calc(1 / 12.5 * 18vh);
      }

      .header_box {
        height: 100%;
        // border-bottom: 1px #04497c solid;
        padding: 0 2%;
        position: relative;
        display: flex;
        justify-content: center;

        >span {
          position: absolute;
          right: 3%;
          top: 5%;
          z-index: 10;
        }
      }

      h1 {
        text-align: center;
        width: 25%;
        font-size: calc(1 / 12.5 * 48vh);
        position: absolute;
        color: #f49e3a;
        left: 50%;
        margin-left: -14.06%;
        top: calc(1 / 10.8 * 50vh);
        background-size: 100% 100%;
        padding-top: calc(1 / 10.8 * 10vh);
        padding-bottom: calc(1 / 10.8 * 20vh);
      }
    }

    // 排名部分
    .rankings_box {
      height: 84%;
      width: 100%;
      position: absolute;
      z-index: 2;
      top: 15%;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-content: center;

      >div {
        width: 96%;
        height: 100%;
        display: flex;
        flex-direction: column;

        // 综合积分排名 与 支部任务积分排行
        .points_ranking {
          height: calc(1 / 10.8 * 300vw);
          display: flex;
          justify-content: space-between;
          align-items: center;

          // border: 1px solid black;
          >div {
            width: 48.5%;
            height: 92%;
            // border: 1px solid black;
            padding: 5px;
            background-color: #ffffff;
          }

          // 支部任务
          .points_left {
            ul {
              height: 100%;
              overflow: auto;

              >li:nth-child(1) {
                color: #e2160d;
                // border: 1px solid black;
                text-indent: 10px;
                font-size: calc(1 / 12.5 * 15vw);
                position: relative;
              }

              >li:nth-child(1)::before {
                content: "";
                position: absolute;
                left: 3px;
                top: 15%;
                width: 2px;
                height: calc(1 / 12.5 * 15vw);
                background-color: #e2160d;
              }

              >li:nth-child(2) {
                width: 100%;
                height: 36%;
                // background-color: red;
                display: flex;
                justify-content: space-between;
                position: relative;
                overflow: hidden;

                >div {
                  flex: 1;
                  position: absolute;
                  bottom: 0;
                  // border: 1px solid black;
                }

                .tow_box {
                  // border: 1px solid black;
                  width: 33%;
                  left: 0;
                  height: 70%;
                  bottom: 0;
                  background-color: #58c9a3;
                  border-radius: calc(1 / 12.5 * 10vw);
                  z-index: 4;
                  display: flex;
                  justify-content: space-around;
                  text-align: center;
                  padding: calc(1 / 12.5 * 3vw);

                  // 皇冠
                  .huangguang {
                    // width: calc(1 / 12.5 * 30vw);
                    height: calc(1 / 12.5 * 19vw);
                  }

                  // 文字
                  .tow_text {
                    font-size: calc(1 / 12.5 * 70vw);
                    font-weight: bold;
                    color: #15ae7a;
                    margin-top: calc(1 / 12.5 * -10vw);
                  }

                  // 图片分数显示
                  .img_box {
                    margin-top: 4%;
                    width: 100%;
                    height: 85%;
                    display: flex;

                    >img {
                      width: 42%;
                      height: 100%;
                      margin-left: 10px;
                    }

                    .img_text_box {
                      flex: 1;
                      display: flex;
                      flex-direction: column;
                      padding: 10px 0;
                      box-sizing: border-box;

                      .fenshu_Combox {
                        font-size: calc(1 / 12.5 * 18vw);
                        overflow: hidden; //超出的文本隐藏
                        text-overflow: ellipsis; //溢出用省略号显示
                        white-space: nowrap; //溢出不换行
                        color: #e2160d;
                      }

                      .name_Combox {
                        font-size: calc(1 / 12.5 * 15vw);
                        overflow: hidden; //超出的文本隐藏
                        text-overflow: ellipsis; //溢出用省略号显示
                        white-space: nowrap; //溢出不换行
                        color: #ffffff;
                      }
                    }
                  }
                }

                .one_box {
                  left: 33%;
                  bottom: 0;
                  height: 100%;
                  background-color: #ff4444;
                  z-index: 5;
                  width: 35%;
                  text-align: center;
                  color: white;
                  transform: skewX(-20deg);
                  display: flex;
                  justify-content: space-around;
                  text-align: center;
                  padding: calc(1 / 12.5 * 1vw);

                  // 皇冠
                  .huangguang {
                    transform: skewX(20deg);
                    // width: calc(1 / 12.5 * 30vw);
                    margin-left: 3%;
                    margin-top: 1%;
                    height: calc(1 / 12.5 * 19vw);
                  }

                  // 文字
                  .tow_text {
                    transform: skewX(20deg);
                    font-size: calc(1 / 12.5 * 100vw);
                    font-weight: bold;
                    color: #e2160d;
                    margin-top: calc(1 / 12.5 * -15vw);
                    margin-left: 2%;
                  }

                  // 图片分数显示
                  .img_box {
                    transform: skewX(20deg);
                    margin-top: 17%;
                    margin-left: 1%;
                    width: 100%;
                    height: 61%;
                    display: flex;
                    justify-content: space-between;

                    >img {
                      width: 87.08px !important;
                      height: 100%;
                    }

                    .img_text_box {
                      width: 80%;
                      display: flex;
                      flex-direction: column;
                      padding-left: 15px;
                      justify-content: center;

                      .fenshu_Combox {
                        font-size: calc(1 / 12.5 * 18vw);
                        overflow: hidden; //超出的文本隐藏
                        text-overflow: ellipsis; //溢出用省略号显示
                        white-space: nowrap; //溢出不换行
                        color: #fff;
                      }

                      .name_Combox {
                        font-size: calc(1 / 12.5 * 15vw);
                        overflow: hidden; //超出的文本隐藏
                        text-overflow: ellipsis; //溢出用省略号显示
                        white-space: nowrap; //溢出不换行
                        color: #ffffff;
                      }
                    }
                  }
                }

                .three_box {
                  width: 36%;
                  left: 63%;
                  bottom: 0;
                  height: 70%;
                  border-radius: 10px;
                  background-color: #ff8c28;
                  z-index: 4;
                  display: flex;
                  justify-content: space-around;
                  text-align: center;
                  padding: calc(1 / 12.5 * 3vw);

                  // 皇冠
                  .huangguang {
                    // width: calc(1 / 12.5 * 30vw);
                    height: calc(1 / 12.5 * 19vw);
                  }

                  // 文字
                  .tow_text {
                    font-size: calc(1 / 12.5 * 70vw);
                    font-weight: bold;
                    color: #d56d12;
                    margin-top: calc(1 / 12.5 * -10vw);
                    margin-left: 15%;
                  }

                  // 图片分数显示
                  .img_box {
                    margin-top: 4%;
                    width: 53%;
                    height: 85%;
                    display: flex;

                    >img {
                      width: 42%;
                      height: 100%;
                      margin-left: 10px;
                    }

                    .img_text_box {
                      flex: 1;
                      display: flex;
                      flex-direction: column;
                      justify-content: center;

                      .fenshu_Combox {
                        font-size: calc(1 / 12.5 * 18vw);
                        overflow: hidden; //超出的文本隐藏
                        text-overflow: ellipsis; //溢出用省略号显示
                        white-space: nowrap; //溢出不换行
                        color: #e2160d;
                      }

                      .name_Combox {
                        font-size: calc(1 / 12.5 * 15vw);
                        overflow: hidden; //超出的文本隐藏
                        text-overflow: ellipsis; //溢出用省略号显示
                        white-space: nowrap; //溢出不换行
                        color: #ffffff;
                      }
                    }
                  }
                }
              }

              >li:nth-child(3)::-webkit-scrollbar {
                width: 0 !important
              }

              >li:nth-child(3) {
                //  border: 1px solid black;
                height: 54%;
                overflow: auto;

                .v_for_box {
                  display: flex;
                  justify-content: space-between;
                  padding: 2px 10px;
                  height: 50px;
                  border-radius: calc(1 / 12.5 * 10vw);
                  margin-bottom: 1%;
                  height: calc(1 / 12.5 * 30vw);
                  background-color: #ffbbbb;

                  // 分数1
                  .fenshu_boxs {
                    width: 22%;
                    font-size: calc(1 / 12.5 * 28vh);
                    color: #e2160d;
                    display: flex;
                    align-items: center;
                    text-align: right;
                    overflow: hidden; //超出的文本隐藏
                    text-overflow: ellipsis; //溢出用省略号显示
                    white-space: nowrap; //溢出不换行
                    justify-content: flex-end;
                    padding-right:95px;
                  }

                  .rangin_conbox {
                    // border: 1px solid black;
                    width: 50%;
                    display: flex;
                    justify-content: space-between;
                    align-content: center;
                    text-align: center;

                    .rangin_img {
                      /* width: calc(1 / 12.5 * 30vw); */
                      height: calc(1 / 12.5 * 30vw);
                      display: flex;
                      justify-content: center;
                      align-content: center;
                    }

                    .points_wenzi {
                      display: flex;
                      align-items: center;
                      width: 10%;
                      font-size: calc(1 / 12.5 * 28vh);
                      // border: 1px solid black;
                      overflow: hidden; //超出的文本隐藏
                      text-overflow: ellipsis; //溢出用省略号显示
                      white-space: nowrap; //溢出不换行
                      font-size: calc(1 / 12.5 * 12vw);
                    }

                    .points_name {
                      font-size: calc(1 / 12.5 * 12vw);
                      width: 60%;
                      overflow: hidden; //超出的文本隐藏
                      text-overflow: ellipsis; //溢出用省略号显示
                      white-space: nowrap; //溢出不换行
                    }
                  }
                }
              }
            }
          }

          .points_right {
            overflow: auto;

            ul {
              height: 100%;

              >li:nth-child(1) {
                color: #e2160d;
                // border: 1px solid black;
                text-indent: 10px;
                font-size: calc(1 / 12.5 * 15vw);
                position: relative;
              }

              >li:nth-child(1)::before {
                content: "";
                position: absolute;
                left: 3px;
                top: 15%;
                width: 2px;
                height: calc(1 / 12.5 * 15vw);
                background-color: #e2160d;
              }

              >li:nth-child(2) {
                display: flex;
                justify-content: space-around;
                width: 100%;
                height:185px;
                .noNumber {
                  font-size: calc(1 / 12.5 * 15vw);
                  color: #ffff;
                  padding-top: 10px;
                  padding-bottom: 5px;
                }

                .noNumber::before {
                  width: 0 !important;
                }

                .top_10 {
                  margin-top: 2%;
                }

                .top_20 {
                  margin-top: 4%;
                }

                .points_img {
                  width: 17%;
                  height: 100%;
                  background: url("../../../../assets/images/h1.png") no-repeat center center;
                  background-size: 120% 100%;
                  text-align: center;
                  display: flex;
                  flex-direction: column;
                  align-items: center;

                  .points_boxs {
                    width: 38%;
                    height: 29%;

                    >img {
                      display: block;
                      width: 100%;
                      height: 100%;
                      // border-radius: 50%;
                    }
                  }

                  // 文字
                  .points_consboc {
                    font-size: calc(1 / 12.5 * 12vw);
                    overflow: hidden; //超出的文本隐藏
                    text-overflow: ellipsis; //溢出用省略号显示
                    white-space: nowrap; //溢出不换行
                    padding-bottom:10px;
                  }

                  .points_consbocs {
                    width: 100%;
                    font-size: calc(1 / 12.5 * 16vw);
                    color: #fff;
                    overflow: hidden; //超出的文本隐藏
                    text-overflow: ellipsis; //溢出用省略号显示
                    white-space: nowrap; //溢出不换行
                  }
                }

                .points_img1 {
                  width: 17%;
                  height: 100%;
                  background: url("../../../../assets/images/lu1.png") no-repeat center center;
                  background-size: 120% 100%;
                  text-align: center;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  overflow: hidden; //超出的文本隐藏
                  text-overflow: ellipsis; //溢出用省略号显示
                  white-space: nowrap; //溢出不换行

                  .points_boxs {
                    width: 38%;
                    height: 29%;

                    >img {
                      display: block;
                      width: 100%;
                      height: 100%;
                      // border-radius: 50%;
                    }
                  }

                  // 文字
                  .points_consboc {
                    width: 100%;
                    font-size: calc(1 / 12.5 * 12vw);
                    overflow: hidden; //超出的文本隐藏
                    text-overflow: ellipsis; //溢出用省略号显示
                    white-space: nowrap; //溢出不换行
                  }

                  .points_consbocs {
                    width: 100%;
                    font-size: calc(1 / 12.5 * 16vw);
                    color: #e2160d;
                    overflow: hidden; //超出的文本隐藏
                    text-overflow: ellipsis; //溢出用省略号显示
                    white-space: nowrap; //溢出不换行
                  }
                }

                .points_img2 {
                  width: 17%;
                  height: 100%;
                  background: url("../../../../assets/images/lan1.png") no-repeat center center;
                  background-size: 120% 100%;

                  text-align: center;
                  display: flex;
                  flex-direction: column;
                  align-items: center;

                  .points_boxs {
                    width: 38%;
                    height: 29%;

                    >img {
                      display: block;
                      width: 100%;
                      height: 100%;
                      // border-radius: 50%;
                    }
                  }

                  // 文字
                  .points_consboc {
                    font-size: calc(1 / 12.5 * 12vw);
                    overflow: hidden; //超出的文本隐藏
                    text-overflow: ellipsis; //溢出用省略号显示
                    white-space: nowrap; //溢出不换行
                    padding-bottom:10px;
                  }

                  .points_consbocs {
                    width: 100%;
                    font-size: calc(1 / 12.5 * 16vw);
                    color: #e2160d;
                    overflow: hidden; //超出的文本隐藏
                    text-overflow: ellipsis; //溢出用省略号显示
                    white-space: nowrap; //溢出不换行
                  }
                }
              }

              >li:nth-child(3)::-webkit-scrollbar {
                width: 0 !important
              }

              >li:nth-child(3) {
                overflow: auto;

                .v_for_box {
                  display: flex;
                  justify-content: space-between;
                  padding: 0px 10px;
                  height: 50px;
                  margin-top: 1%;
                  height: calc(1 / 12.5 * 30vw);
                  padding-bottom: 5px;
                  border-bottom: 1px solid #707070;

                  // 分数2
                  .fenshu_boxs {
                    width: 22%;
                    font-size: calc(1 / 12.5 * 28vh);
                    color: #e2160d;
                    display: flex;
                    overflow: hidden; //超出的文本隐藏
                    text-overflow: ellipsis; //溢出用省略号显示
                    white-space: nowrap; //溢出不换行
                    align-items: center;
                    justify-content: flex-end;
                    padding-right:20px;
                  }

                  .rangin_conbox {
                    // border: 1px solid black;
                    width: 50%;
                    display: flex;
                    justify-content: space-between;
                    align-content: center;
                    text-align: center;

                    .rangin_img {
                      width: calc(1 / 12.5 * 30vw);
                      height: calc(1 / 12.5 * 30vw);
                      display: flex;
                      justify-content: center;
                      align-content: center;
                    }

                    .points_wenzi {
                      display: flex;
                      align-items: center;
                      width: 10%;
                      overflow: hidden; //超出的文本隐藏
                      text-overflow: ellipsis; //溢出用省略号显示
                      white-space: nowrap; //溢出不换行
                      font-size: calc(1 / 12.5 * 12vw);
                    }

                    .points_name {
                      font-size: calc(1 / 12.5 * 12vw);
                      display: flex;
                      align-items: center;
                      width: 60%;
                      overflow: hidden; //超出的文本隐藏
                      text-overflow: ellipsis; //溢出用省略号显示
                      white-space: nowrap; //溢出不换行
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    }
                  }
                }
              }
            }
          }
        }

        // 底部排行 学习积分 登录积分 组织生活积分
        .bottom_ranking {
          height: calc(1 / 10.8 * 400vh);
          display: flex;
          justify-content: space-between;
          align-items: center;

          >div {
            width: 32%;
            height: 92%;

            padding: 5px;
            background-color: #ffffff;
          }

          // 学习排行
          .learning {
            /* overflow: auto; */
            height: 100%;

            ul {
              height: 100%;
              display: flex;
              flex-direction: column;
            }

            ul {
              >li:nth-child(1) {
                color: #e2160d;
                font-size: calc(1 / 12.5 * 15vw);
                text-indent: 10px;
                position: relative;
              }

              >li:nth-child(1)::before {
                content: "";
                position: absolute;
                left: 3px;
                top: 15%;
                width: 2px;
                height: calc(1 / 12.5 * 15vw);
                background-color: #e2160d;
              }

              .ranking_li2::-webkit-scrollbar {
                width: 0 !important
              }

              .ranking_li2 {
                /* height: 40%; */
                flex: 1;
                overflow: scroll;

                .v_for_box {
                  display: flex;
                  justify-content: space-between;
                  padding: 0px 10px;
                  height: 50px;
                  margin-top: 2%;
                  height: calc(1 / 12.5 * 30vw);
                  padding-bottom: 5px;

                  // 分数
                  .fenshu_boxs {
                    width: 32%;
                    font-size: calc(1 / 12.5 * 28vh);
                    color: #e2160d;
                    display: flex;
                    align-items: center;
                    text-align: center;
                    overflow: hidden; //超出的文本隐藏
                    text-overflow: ellipsis; //溢出用省略号显示
                    white-space: nowrap; //溢出不换行
                    justify-content: flex-end;
                    padding-right:40px;
                  }

                  .rangin_conbox {
                    width: 60%;
                    display: flex;
                    /* justify-content: space-between; */
                    align-content: center;
                    text-align: center;

                    .rangin_img1 {
                      width: 12%;
                      display: flex;
                      align-items: center;
                    }

                    .rangin_img {
                      width: calc(1 / 12.5 * 30vw);
                      height: calc(1 / 12.5 * 30vw);
                    }

                    .points_wenzi {
                      display: flex;
                      align-items: center;
                      width: 20%;
                      margin-left: 3%;
                      overflow: hidden; //超出的文本隐藏
                      text-overflow: ellipsis; //溢出用省略号显示
                      white-space: nowrap; //溢出不换行
                      font-size: calc(1 / 12.5 * 12vw);
                    }

                    .points_name {
                      font-size: calc(1 / 12.5 * 12vw);
                      width: 50%;
                      display: flex;
                      align-items: center;
                      // border: 1px solid black;
                      overflow: hidden; //超出的文本隐藏
                      text-overflow: ellipsis; //溢出用省略号显示
                      white-space: nowrap; //溢出不换行
                      padding-left: 15px;
                      box-sizing: border-box;
                    }
                  }
                }
              }
            }
          }

          // 登录积分排行
          .logining {
            overflow: auto;

            ul {
              >li:nth-child(1) {
                color: #e2160d;

                text-indent: 10px;
                font-size: calc(1 / 12.5 * 15vw);
                position: relative;
              }

              >li:nth-child(1)::before {
                content: "";
                position: absolute;
                left: 3px;
                top: 15%;
                width: 2px;
                height: calc(1 / 12.5 * 15vw);
                background-color: #e2160d;
              }

              .ranking_li2 {
                height: 40%;
                overflow: auto;

                .v_for_box {
                  display: flex;
                  justify-content: space-between;
                  padding: 0px 10px;
                  margin-top: 2%;
                  height: calc(1 / 12.5 * 30vw);
                  padding-bottom: 5px;

                  // 分数
                  .fenshu_boxs {
                    width: 32%;
                    color: #e2160d;
                    display: flex;
                    align-items: center;
                    overflow: hidden; //超出的文本隐藏
                    text-overflow: ellipsis; //溢出用省略号显示
                    white-space: nowrap; //溢出不换行
                    font-size: calc(1 / 12.5 * 28vh);
                    justify-content: flex-end;
                    padding-right:20px;
                  }

                  .rangin_conbox {
                    width: 60%;
                    display: flex;
                    justify-content: space-between;
                    align-content: center;
                    text-align: center;

                    .rangin_img1 {
                      width: 25%;

                      display: flex;
                      align-items: center;
                    }

                    .rangin_img {
                      width: calc(1 / 12.5 * 30vw);
                      height: calc(1 / 12.5 * 30vw);
                    }

                    .points_wenzi {
                      display: flex;
                      align-items: center;
                      width: 9%;
                      margin-left: 3%;
                      overflow: hidden; //超出的文本隐藏
                      text-overflow: ellipsis; //溢出用省略号显示
                      white-space: nowrap; //溢出不换行
                      font-size: calc(1 / 12.5 * 12vw);
                    }

                    .points_name {
                      // border: 1px solid black;
                      font-size: calc(1 / 12.5 * 12vw);
                      display: flex;
                      align-items: center;
                      width: 50%;
                      overflow: hidden; //超出的文本隐藏
                      text-overflow: ellipsis; //溢出用省略号显示
                      white-space: nowrap; //溢出不换行
                    }
                  }
                }
              }
            }
          }

          // 组织生活排行
          .Organizational_lisfe {
            overflow: hidden;
            display: flex;
            flex-direction: column;

            ul {
              >li:nth-child(1) {
                color: #e2160d;
                text-indent: 10px;
                font-size: calc(1 / 12.5 * 15vw);
                position: relative;
              }

              >li:nth-child(1)::before {
                content: "";
                position: absolute;
                left: 3px;
                top: 15%;
                width: 2px;
                height: calc(1 / 12.5 * 15vw);
                background-color: #e2160d;
              }

              .ranking_li2 {
                /* height: 40%; */
                flex: 1;
                overflow: scroll;

                .v_for_box {
                  display: flex;
                  justify-content: space-between;
                  padding: 0px 10px;
                  height: 50px;
                  margin-top: 2%;
                  height: calc(1 / 12.5 * 30vw);
                  padding-bottom: 5px;

                  // 分数
                  .fenshu_boxs {
                    width: 32%;
                    color: #e2160d;
                    display: flex;
                    align-items: center;
                    overflow: hidden; //超出的文本隐藏
                    text-overflow: ellipsis; //溢出用省略号显示
                    white-space: nowrap; //溢出不换行
                    font-size: calc(1 / 12.5 * 28vh);
                    justify-content: flex-end;
                    padding-right:20px;
                  }

                  .rangin_conbox {
                    width: 60%;
                    display: flex;
                    justify-content: space-between;
                    align-content: center;
                    text-align: center;

                    .rangin_img1 {
                      width: 25%;

                      display: flex;
                      align-items: center;
                    }

                    .rangin_img {
                      width: calc(1 / 12.5 * 30vw);
                      height: calc(1 / 12.5 * 30vw);
                    }

                    .points_wenzi {
                      display: flex;
                      align-items: center;
                      width: 20%;
                      margin-left: 3%;
                      overflow: hidden; //超出的文本隐藏
                      text-overflow: ellipsis; //溢出用省略号显示
                      white-space: nowrap; //溢出不换行
                      font-size: calc(1 / 12.5 * 12vw);
                    }

                    .points_name {
                      display: flex;
                      font-size: calc(1 / 12.5 * 12vw);
                      align-items: center;
                      width: 50%;
                      overflow: hidden; //超出的文本隐藏
                      text-overflow: ellipsis; //溢出用省略号显示
                      white-space: nowrap; //溢出不换行
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Works/Ranking/Leader/index.vue